import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
/** Capability tags shown on team cards (UI labels mapped in the dashboard). */
export const TeamCapabilitySchema = z.enum([
    'manage_displays',
    'upload_assets',
    'edit_playlists',
    'view_reports',
    'manage_schedules',
]);
export const TeamScopeSchema = z.enum(['all_locations', 'locations']);
export const CreateTeamRequestSchema = z
    .object({
    name: z.string().min(1).max(120),
    scope: TeamScopeSchema.default('all_locations'),
    locationIds: z.array(z.string().min(1)).max(100).default([]),
    capabilities: z.array(TeamCapabilitySchema).max(10).default([]),
    memberUserIds: z.array(z.string().min(1)).max(200).default([]),
})
    .superRefine((value, ctx) => {
    if (value.scope === 'locations' && value.locationIds.length === 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'locationIds required when scope is locations',
            path: ['locationIds'],
        });
    }
    if (value.scope === 'all_locations' && value.locationIds.length > 0) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'locationIds must be empty when scope is all_locations',
            path: ['locationIds'],
        });
    }
});
export const UpdateTeamRequestSchema = z
    .object({
    name: z.string().min(1).max(120).optional(),
    scope: TeamScopeSchema.optional(),
    locationIds: z.array(z.string().min(1)).max(100).optional(),
    capabilities: z.array(TeamCapabilitySchema).max(10).optional(),
    memberUserIds: z.array(z.string().min(1)).max(200).optional(),
})
    .refine((value) => Object.keys(value).length > 0, {
    message: 'At least one field is required',
});
export const TeamSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().min(1),
    scope: TeamScopeSchema,
    capabilities: z.array(TeamCapabilitySchema),
    memberCount: z.number().int().nonnegative(),
    locationIds: z.array(z.string().min(1)),
    locationCount: z.number().int().nonnegative(),
    displayCount: z.number().int().nonnegative(),
    memberUserIds: z.array(z.string().min(1)),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
export const AddTeamMemberRequestSchema = z.object({
    userId: z.string().min(1),
});
/** Roles that can be invited (owners bootstrap themselves; platform_admin is internal). */
export const InviteRoleSchema = z.enum([
    'organisation_admin',
    'location_manager',
    'content_manager',
    'viewer',
]);
export const CreateInvitesRequestSchema = z.object({
    emails: z
        .array(z.string().email().max(320))
        .min(1)
        .max(20)
        .transform((emails) => [...new Set(emails.map((email) => email.trim().toLowerCase()))]),
    role: InviteRoleSchema,
});
export const OrganisationInviteSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    email: z.string().email(),
    role: InviteRoleSchema,
    status: z.enum(['pending', 'accepted', 'revoked']),
    invitedBy: z.string().nullable(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema,
});
//# sourceMappingURL=team.js.map